import { ca } from '@cian/analytics';
import { IPromoProduct } from '../../../types/product';

interface ITrackPromoClickParams {
  product: IPromoProduct;
}

export const trackListingJKClick = ({ product }: ITrackPromoClickParams) => {
  ca('eventSite', {
    action: 'Click',
    category: 'Promo',
    name: 'oldevent',
    label: 'to_listingjk',
    products: [product],
  });
};
